<template>
	<div @click="ControlMusic" class="radio">

		<audio ref="music">
			<source src="../../resources/sound/sound.mp3">
		</audio>

		<div class="radio--radio">
			<icon-base
							width="100%"
							height="100%"
							ViewWidth="603.7"
							ViewHeight="546.5"
			><icon-radio
				ref="compRadio"
			></icon-radio></icon-base>
		</div>

		<div ref="radio_pause" class="radio--pause">
			<icon-base
							width="100%"
							height="100%"
							ViewWidth="439"
							ViewHeight="439"
			><icon-pause/></icon-base>
		</div>

		<div ref="radio_play" class="radio--play">
			<icon-base
							width="100%"
							height="100%"
							ViewWidth="233"
							ViewHeight="233"
			><icon-play/></icon-base>
		</div>

	</div>
</template>

<script>
	import IconBase from '../icon/IconBase.vue'
	import IconRadio from '../icon/IconRadio.vue'
	import IconPlay from '../icon/IconPlay.vue'
	import IconPause from '../icon/IconPause.vue'
	import { TimelineMax, Power0 } from 'gsap'

	export default {
		name: "RadioAnim",
		components: {
			IconBase,
			IconRadio,
			IconPlay,
			IconPause
		},
		data: function () {
			return{
				music:undefined,
				button:false,
				playing:false,
				radio:undefined,
			}
		},
		mounted() {
			this.music = this.$refs.music;
			this.radio = this.$refs.compRadio;
		},
		methods: {
			playMusic() {
				if (this.music !=undefined) {
					var promise = this.music.play();

					if (promise !== null && promise != undefined){
						promise.catch(() => { this.music.play(); })
					}

					this.playing = true;
					this._topPlay();
				}
			},
			stopMusic() {
				if (this.music !=undefined ) {
					var promise = this.music.pause();

					if (promise !== null && promise != undefined) {
						promise.catch(() => {
							this.music.pause();
						})
					}

					this.playing = false;
					this._topPause();
				}
			},
			ControlMusic() {
				this.music.paused ? this.playMusic():this.stopMusic();
			},
			_topPlay(){
				if (this.button === false) {
					this.button = true;

					var play = this.$refs.radio_play;
					const tl = new TimelineMax();
					tl.to(play, 0.5, {y: -30, opacity:1})
					tl.to(play, 0.4, {y: -30, opacity:1})
					tl.to(play, 0.5, {y: 0, opacity:0})

					if (this.radio != undefined) {
						this.radio.play();
					}

					this.button = false;
				}
			},
			_topPause(){
				if (this.button === false) {
					this.button = true;

					var pause = this.$refs.radio_pause;
					const tl = new TimelineMax();
					tl.to(pause, 0.5, {y: -30, opacity:1})
					tl.to(pause, 0.4, {y: -30, opacity:1})
					tl.to(pause, 0.5, {y: 0, opacity:0})

					if (this.radio != undefined) {
						this.radio.stop();
					}

					this.button = false;
				}
			}
		}
	}
</script>

<style>
	.radio--play{
		position: absolute;
		width: 30%;
		left: 35%;
		margin-top: 30%;
		z-index: 2;
		opacity: 0;
	}

	.radio--pause{
		position: absolute;
		width: 30%;
		left: 35%;
		margin-top: 30%;
		z-index: 2;
		opacity: 0;
	}

	.radio--radio {
		z-index: 1;
		position: absolute;
	}

</style>
